// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .mat-filter {
      border-bottom: 1px solid grey;
      border-radius: 0;
      box-shadow: none;
      box-sizing: border-box;
      font-size: inherit;
      padding: 16px;
      position: sticky;
      top: 0;
      z-index: 100;
    }
    .mat-filter-input {
      -webkit-appearance: none;
              appearance: none;
      background-color: unset;
      border: 0;
      color: grey;
      outline: none;
      width: 100%;
    }
    .spinner {
      position: absolute;
      right: 16px;
      top: calc(50% - 8px);
    }
    .noResultsMessage {
      font-family: Roboto, Helvetica Neue, sans-serif;
      font-size: 16px;
      margin-top: 10px;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/shared/mat-select-filter/mat-select-filter.module.ts"],"names":[],"mappings":";IACI;MACE,6BAA6B;MAC7B,gBAAgB;MAChB,gBAAgB;MAChB,sBAAsB;MACtB,kBAAkB;MAClB,aAAa;MACb,gBAAgB;MAChB,MAAM;MACN,YAAY;IACd;IACA;MACE,wBAAgB;cAAhB,gBAAgB;MAChB,uBAAuB;MACvB,SAAS;MACT,WAAW;MACX,aAAa;MACb,WAAW;IACb;IACA;MACE,kBAAkB;MAClB,WAAW;MACX,oBAAoB;IACtB;IACA;MACE,+CAA+C;MAC/C,eAAe;MACf,gBAAgB;IAClB","sourcesContent":["\n    .mat-filter {\n      border-bottom: 1px solid grey;\n      border-radius: 0;\n      box-shadow: none;\n      box-sizing: border-box;\n      font-size: inherit;\n      padding: 16px;\n      position: sticky;\n      top: 0;\n      z-index: 100;\n    }\n    .mat-filter-input {\n      appearance: none;\n      background-color: unset;\n      border: 0;\n      color: grey;\n      outline: none;\n      width: 100%;\n    }\n    .spinner {\n      position: absolute;\n      right: 16px;\n      top: calc(50% - 8px);\n    }\n    .noResultsMessage {\n      font-family: Roboto, Helvetica Neue, sans-serif;\n      font-size: 16px;\n      margin-top: 10px;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
